"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../shared/UiStateController");
var routes_1 = require("../../../shared/includes/routes");
var PartnersContentList_1 = require("./ui/component/PartnersContentList");
var PartnersContentDirEdit_1 = require("./ui/component/PartnersContentDirEdit");
var PartnersContentImgEdit_1 = require("./ui/component/PartnersContentImgEdit");
var fileBinaryChunkedUploadCtl_1 = require("../../../../shared/helpers/fileBinaryChunkedUploadCtl");
var UIUtils_1 = require("../../../../shared/modules/UIUtils");
var PParImagesList = /** @class */ (function (_super) {
    __extends(PParImagesList, _super);
    function PParImagesList(props) {
        return _super.call(this, props) || this;
    }
    PParImagesList.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({
            edit_mode: "TREE",
            brandId: -1,
            dirName: "",
            fileName: ""
        });
        fileBinaryChunkedUploadCtl_1.fileBinaryChunkedReader.setOnInit(function (fileName, fileSize) {
            _this.props.uploadDlg
                .SetErrorTitle("Ошибка загрузки")
                .SetProgressTitle("Загрузка файла")
                .SetProgressText("Загрузка...")
                .SetDisplayMode("progress")
                .SetOnCloseClick(function () {
                _this.props.uploadDlg.Close();
            })
                .SetCanClose(false)
                .SetProgressPercent(0);
            _this.props.contentListData.IsFileExists(_this.props.contentListData.getPProgramItemById(_this.state.brandId), _this.props.contentListData.getDirectoryItemByName(_this.props.contentListData.getPProgramItemById(_this.state.brandId), _this.state.dirName), fileName, function (exists) {
                if (!exists) {
                    _this.props.contentListData.DoCmsPProgramContentFileUploadReset(_this.props.contentListData.getPProgramItemById(_this.state.brandId), _this.props.contentListData.getDirectoryItemByName(_this.props.contentListData.getPProgramItemById(_this.state.brandId), _this.state.dirName), fileName, function () {
                        fileBinaryChunkedUploadCtl_1.fileBinaryChunkedReader.readFileChunk();
                        _this.props.uploadDlg.Show();
                    });
                }
                else {
                    _this.props.uploadDlg
                        .SetDisplayMode("error")
                        .SetCanClose(true)
                        .SetErrorText("Файл с таким именем уже существует")
                        .Show();
                }
            });
        });
        fileBinaryChunkedUploadCtl_1.fileBinaryChunkedReader.setOnDone(function (fileName, fileSize) {
            _this.props.uploadDlg.SetProgressPercent(100.00);
            setTimeout(function () {
                _this.props.contentListData.Update();
                _this.props.uploadDlg.Close();
            }, 1000);
        });
        fileBinaryChunkedUploadCtl_1.fileBinaryChunkedReader.setOnError(function (reason) {
            _this.props.uploadDlg
                .SetErrorText(reason)
                .SetDisplayMode("error")
                .SetCanClose(true);
        });
        fileBinaryChunkedUploadCtl_1.fileBinaryChunkedReader.setOnDataChunk(function (content, fileName, offset, total) {
            _this.props.contentListData.DoCmsPProgramContentFileUploadAppend(_this.props.contentListData.getPProgramItemById(_this.state.brandId), _this.props.contentListData.getDirectoryItemByName(_this.props.contentListData.getPProgramItemById(_this.state.brandId), _this.state.dirName), fileName, UIUtils_1.UIUtils.Base64Encode(content), function () {
                fileBinaryChunkedUploadCtl_1.fileBinaryChunkedReader.readFileChunk();
                _this.props.uploadDlg.SetProgressPercent(Math.round(((offset * 100) / total) * 100) / 100);
            });
        });
    };
    PParImagesList.prototype.onNewDirClick = function (BrandId) {
        this.setState({ edit_mode: "NEW-DIR", brandId: BrandId, dirName: "" });
    };
    PParImagesList.prototype.onEditDirClick = function (BrandId, DirName) {
        this.setState({ edit_mode: "EDIT-DIR", brandId: BrandId, dirName: DirName });
    };
    PParImagesList.prototype.onEditFileClick = function (BrandId, DirName, FileName) {
        this.setState({ edit_mode: "EDIT-FILE", brandId: BrandId, dirName: DirName, fileName: FileName });
    };
    PParImagesList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "TREE", brandId: -1, dirName: "" });
    };
    PParImagesList.prototype.createFileClick = function (BrandId, DirName) {
        this.setState({ brandId: BrandId, dirName: DirName }, function () {
            fileBinaryChunkedUploadCtl_1.fileBinaryChunkedReader.showSelector();
        });
    };
    PParImagesList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW-DIR") {
            return (React.createElement(PartnersContentDirEdit_1.default, { state: this.props.state, data: this.props.contentListData, brand: this.props.contentListData.getPProgramItemById(this.state.brandId), onGoBack: this.onGoBackClick.bind(this) }));
        }
        if (this.state.edit_mode === "EDIT-DIR") {
            return (React.createElement(PartnersContentDirEdit_1.default, { state: this.props.state, data: this.props.contentListData, brand: this.props.contentListData.getPProgramItemById(this.state.brandId), onGoBack: this.onGoBackClick.bind(this), dirName: this.state.dirName }));
        }
        if (this.state.edit_mode === "TREE") {
            return (React.createElement(PartnersContentList_1.default, { ctxData: this.props.contentListData, state: this.props.state, yesNoDlg: this.props.yesNoDlg, onEditDirectory: this.onEditDirClick.bind(this), onCreateDirectory: this.onNewDirClick.bind(this), onEditFile: this.onEditFileClick.bind(this), onCreateFile: this.createFileClick.bind(this) }));
        }
        if (this.state.edit_mode === "EDIT-FILE") {
            return (React.createElement(PartnersContentImgEdit_1.default, { state: this.props.state, data: this.props.contentListData, brand: this.props.contentListData.getPProgramItemById(this.state.brandId), dirName: this.props.contentListData.getDirectoryItemByName(this.props.contentListData.getPProgramItemById(this.state.brandId), this.state.dirName), fileName: this.state.fileName, onGoBack: this.onGoBackClick.bind(this) }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PParImagesList.prototype.render = function () {
        return this.getRenderObject();
    };
    PParImagesList.getPageDescription = function (state) {
        return {
            icon: "images",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_par_images + "-id",
            itemTitle: "Изображения",
            route: routes_1.routes.page_par_images,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PParImagesList;
}(React.Component));
exports.default = PParImagesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_images/PParImagesList.tsx
// module id = 2456
// module chunks = 0